module.exports = __webpack_public_path__ + "img/10_30.e839695f.png";